import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { DeviceNotFoundComponent } from "./components/DeviceNotFoundComponent";
import { HomePage } from "./pages/HomePage";
import { Login } from "./pages/Login";
import { InterpreterPanel } from "./pages/InterpreterPanel";
import { Tutorial } from "./pages/Tutorial";
import { Welcome } from "./pages/Welcome";
import { PrivateRoute } from "./PrivateRoute";
import { NossoTime } from "./pages/NossoTime";
import { RefreshToken } from "./service/RefreshToken";
import Dashboard from "./pages/Dashboard";

export function AppRoutes() {
  return (
    <>
    <RefreshToken />
    <Router>
      <Routes>
        <Route path="/" element={<Welcome />} />
        <Route 
        path="/login" 
        element={
        <Login />
        } 
        />
        <></>
        <Route
          path="/home"
          element={
            <PrivateRoute>
              <HomePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/tutorial"
          element={
            <PrivateRoute>
              <Tutorial />
            </PrivateRoute>
          }
        />
        <Route
          path="/time"
          element={
            <PrivateRoute>
              <NossoTime/>
            </PrivateRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }  
        />
        <Route
          path="/interprete"
          element={
            <PrivateRoute>
              <InterpreterPanel />
            </PrivateRoute>
          }
        />
        <Route path="/naoautorizado" element={<DeviceNotFoundComponent />} />
      </Routes>
    </Router>
    </>
  );
}
